"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var theme_1 = require("../theme");
var styles_1 = tslib_1.__importDefault(require("./styles"));
var HtmlButton = theme_1.styled('button')(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding-top: 0px;\n  padding-bottom: 0px;  // reset browser agent button style\n  -webkit-tap-highlight-color: transparent;\n  vertical-align: middle;\n  ", "\n  ", "\n  ", "\n"], ["\n  padding-top: 0px;\n  padding-bottom: 0px;  // reset browser agent button style\n  -webkit-tap-highlight-color: transparent;\n  vertical-align: middle;\n  ", "\n  ", "\n  ", "\n"])), styles_1.default.getBaseStyle, styles_1.default.getBlockStyle, styles_1.default.getCircleButtonStyle);
var Button = /** @class */ (function (_super) {
    tslib_1.__extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, disabled = _a.disabled, onClick = _a.onClick, uia = _a.uia, innerRef = _a.innerRef, id = _a.id, type = _a.type, ref = _a.ref, restProps = tslib_1.__rest(_a, ["children", "className", "disabled", "onClick", "uia", "innerRef", "id", "type", "ref"]);
        var onClickAction = disabled ? function () { } : onClick;
        return (react_1.default.createElement(HtmlButton, tslib_1.__assign({ role: "button", id: id, "data-uia-button-disabled": disabled, "data-uia-button": uia, className: className, onClick: onClickAction, innerRef: innerRef, disabled: disabled, type: type }, restProps), children));
    };
    Button.defaultProps = {
        color: 'ctaPrimary',
        fontColor: 'light',
        fullWidth: false,
        size: 'medium',
        type: 'button',
    };
    return Button;
}(react_1.default.PureComponent));
/**
 *
 * @component
 */
exports.default = Button;
var templateObject_1;
